import type { ProtocolView } from './protocol';
import type { AgentId } from './types';

/** Public, non-secret configuration the runtime exposes to the website. */
export interface PublicConfig {
  name: string;
  symbol: string;
  mode: 'sim' | 'live';
  chainId: number;
  network: string;
  explorerUrl: string;
  ponsUrl: string | null;
  tokenAddress: string | null;
  contracts: {
    treasury: string | null;
    vaults: Record<AgentId, string | null>;
  };
  socials: {
    x: string | null;
    /** Invite link to the Telegram community all four agent bots post into. */
    telegram: string | null;
    /** Each agent's bot username (without @), learned from the Bot API at startup. */
    telegramBots: Record<AgentId, string | null>;
  };
}

/** Response of `GET /api/view`. */
export interface ApiSnapshot {
  config: PublicConfig;
  view: ProtocolView;
  /** Server time of the response (ms). */
  servedAt: number;
}

export const API_ROUTES = {
  view: '/api/view',
  health: '/api/health',
  events: '/api/events',
} as const;

export const ROBINHOOD_CHAIN = {
  id: 4663,
  name: 'Robinhood Chain',
  explorer: 'https://robinhoodchain.blockscout.com',
} as const;

export const DEFAULT_PUBLIC_CONFIG: PublicConfig = {
  name: 'Quintessence',
  symbol: 'ESSENCE',
  mode: 'sim',
  chainId: ROBINHOOD_CHAIN.id,
  network: ROBINHOOD_CHAIN.name,
  explorerUrl: ROBINHOOD_CHAIN.explorer,
  ponsUrl: 'https://ponsfamily.com/launchpad',
  tokenAddress: null,
  contracts: { treasury: null, vaults: { pyre: null, hoard: null, rain: null, tide: null } },
  socials: { x: null, telegram: null, telegramBots: { pyre: null, hoard: null, rain: null, tide: null } },
};
